import aghapi from '../../api/aghapi.js'
import {httpJsonp} from '../../../../api/base'
import Cookies from 'js-cookie'
import aghStorage from '../../assets/js/myStorage.js'

const USER_DETAIL='USER_DETAIL'
const MY_WELFARE='MY_WELFARE'
const MY_CARDS='MY_CARDS'
const MY_ACTIVITY='MY_ACTIVITY'
const ADDRESS='ADDRESS'
const EDIT_ADDRESS='EDIT_ADDRESS'
const EDIT_ADDRESS_STATUS='EDIT_ADDRESS_STATUS'
const ADD_ADDRESS_STATUS='ADD_ADDRESS_STATUS'
const DEL_ADDRESS_STATUS='DEL_ADDRESS_STATUS'
const UPDATE_ADDRESS_STATUS='UPDATE_ADDRESS_STATUS'
const ADDRESS_BACK_URL='ADDRESS_BACK_URL'
const FOOTER_MENU_SHOW='FOOTER_MENU_SHOW'
const CORP_ID='CORP_ID'
const USER_AGENT='USER_AGENT'
const USER_SECTION_CHECK='USER_SECTION_CHECK'
const GET_USER_INFO='GET_USER_INFO'
const USER_INFO='USER_INFO'
const USER_LOGIN_FINISH='USER_LOGIN_FINISH'
const CURRENT_CORP_ID='CURRENT_CORP_ID'


const state = {
    userDetail:{},
    myActivity:{},
    myCards:{},
    myWelfare:{},
    address:{},
    editAddress:JSON.parse(aghStorage.getItem("leditAddress")),
    choiceAddress:'',
    addAddressStatus:'',
    editAddressStatus:'',
    updateAddressStatus:'',
    delAddressStatus:'',
    addressBackUrl:JSON.parse(aghStorage.getItem("laddressBack")),
    isShowMergeNav:aghStorage.getItem("lisShowMergeNav")||0,
    corpId:'',
    isWxAgent:aghStorage.getItem("isWxWork"),
    userSectionCheck:null,
    getUserInfo:'',
    userInfo: null,
    userLoginFinish: null,
    currentCorpId: null
}

// getters
const getters = {
   getuserDetail:state=>{return state.userDetail},
   getmyActivity:state=>{return state.myActivity},
   getmyCards:state=>{return state.myCards},
   getmyWelfare:state=>{return state.myWelfare},
   getaddress:state=>{return state.address},
   geteditAddressItem:state=>{return state.editAddress},
   getaddressBackUrl:state=>{return state.addressBackUrl},
   getaddAddressStatus:state=>{return state.addAddressStatus},
   geteditAddressStatus:state=>{return state.editAddressStatus},
   getdelAddressStatus:state=>{return state.delAddressStatus},
   getupdateAddressStatus:state=>{return state.updateAddressStatus},
   getisShowMergeNav:state=>{return state.isShowMergeNav},
   getcorpId:state=>{return state.corpId},
   getisWxAgent:state=>{return state.isWxAgent},
   getUserSectionCheck:state=>{return state.userSectionCheck},
   getUserInfo:state=>{return state.getUserInfo},
   userInfo:state=>{return state.userInfo},
   userLoginFinish:state=>{return state.userLoginFinish},
   currentCorpId:state=>{return state.currentCorpId}
}

// actions
const actions = {
    loaduserDetail({commit},params){
        aghapi.getUserDetail(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(USER_DETAIL,{data:res.data.body})
            }
        })
    },
    loadMyWelfare({commit},params){
        aghapi.getMyWelfare(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(MY_WELFARE,{data:res.data.body})
            }
        })
    },
    loadMyCards({commit},params){
        aghapi.getMyCards(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(MY_CARDS,{data:res.data.body})
            }
        })
    },
    loadMyActity({commit},params){
        aghapi.getMyActity(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(MY_ACTIVITY,{data:res.data.body})
            }
        })
    },
    loadAddress({commit},params){
        aghapi.getAddress(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(ADDRESS,{data:res.data.body})
            }
        })
    },
    getEditAddress({commit},data){
        let Obj=JSON.stringify(data)
        aghStorage.setItem("leditAddress",Obj)
       commit(EDIT_ADDRESS,{data:data})
    },
    getAddressBack({commit},data){
        console.log("ABACK",data)
        let Obj=JSON.stringify(data)
        aghStorage.setItem("laddressBack",Obj)
        commit(ADDRESS_BACK_URL,{data:data})
    },
    doEditAddress({commit},params){
        aghapi.editAddress(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                let data=res.data.body+'&'+new Date().getTime();
                commit(EDIT_ADDRESS_STATUS,{data:data})
            }else{
                let error=res.error||'地址更新失败'
                commit(EDIT_ADDRESS_STATUS,{data:error})
            }
        })
    },
    doUpdateAddress({commit},params){
        aghapi.updateDefaultAddress(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                let data=res.data.body+'&'+new Date().getTime();
                commit(UPDATE_ADDRESS_STATUS,{data:data})
            }else{
                let error=res.error||'地址更新失败'
                commit(UPDATE_ADDRESS_STATUS,{data:error})
            }
        })
    },
    doAddAddress({commit},params){
        aghapi.addAddress(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                let data=res.data.body+'&'+new Date().getTime();
                commit(ADD_ADDRESS_STATUS,{data:data})
            }else{
                let error=res.error||'地址添加失败'
                commit(ADD_ADDRESS_STATUS,{data:error})
                
            }
        })
    },
    delAddress({commit},params){
    	aghapi.delAddress(params).then((res)=>{
    		if(res.data&&res.data.errno==0){
                let data=res.data.body+'&'+new Date().getTime();
    			commit(DEL_ADDRESS_STATUS,{data:data})
    		}else{
                let error=res.error||'地址删除失败'
                commit(DEL_ADDRESS_STATUS,{data:error})
            }
    	})
    },
    showMergeNav({commit},params){
        aghapi.getIsShowMergeNav(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                aghStorage.setItem("lisShowMergeNav",JSON.stringify(res.data.body))
                commit(FOOTER_MENU_SHOW, {data:res.data.body})
            }
        })
    },
    switchCompany({commit},params){
        let id=Number(params.corpId);
        aghapi.switchCompany(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                 let date =id+Math.random();
                 commit(CORP_ID,{data:date})
                 commit(USER_LOGIN_FINISH, true)
            }else{
                let error='公司切换失败';
                commit(CORP_ID,{data:error})
            }
        })
    },
    loadIsWxWorkAgent({commit},params){
        // alert(navigator.userAgent.toLowerCase())
        if(/wxwork/.test(navigator.userAgent.toLowerCase())){

            aghStorage.setItem("isWxWork",true)
            commit(USER_AGENT,{data:true})
        }else{
            aghStorage.setItem("isWxWork",false)
            commit(USER_AGENT,{data:false})
        }
    },
    userSectionCheck({commit},params){
        // alert(navigator.userAgent.toLowerCase())
        aghapi.sessionCheck(params).then(function(res){
            if(res.data&&res.data.errno==0){
                let data=new Date().getTime();
                commit(USER_SECTION_CHECK,{data:data})
            }
        })
    },
    loadUserInfo({ commit }, params) {
        aghapi.userInfo(params).then(res => {
            console.log(res)
            if (res && res.data && res.data.errno === 0 ) {
                commit(GET_USER_INFO,res.data.body)
            }
        })
    },
    getUserinfo({ commit }, params) {
        aghapi.getUserinfo(params).then(res => {
            if (res && res.data && res.data.errno === 0 ) {
                commit(USER_INFO,res.data.body)
            }
        })
    },
    userLoginFinish({ commit }, params) {
        commit(USER_LOGIN_FINISH, true);
        commit(CURRENT_CORP_ID, params.corpId);
        setTimeout(() => {
            let date = params.corpId+Math.random();
            commit(CORP_ID,{data: date})
        }, 100);
    },
    setCurrentCorpId({ commit }, currentCorpId) {
        commit(CURRENT_CORP_ID, currentCorpId);
    },
}

// mutations
const mutations = {
    [USER_DETAIL](state, { data }) {
        state.userDetail = data
    },
    [MY_WELFARE](state, { data }) {
        state.myWelfare = data
    },
    [MY_CARDS](state, { data }) {
        state.myCards = data
    },
    [MY_ACTIVITY](state, { data }) {
        state.myActivity = data
    },
    [ADDRESS](state, { data }) {
        state.address = data
    },
    [EDIT_ADDRESS](state, { data }) {
        
        state.editAddress = JSON.parse(aghStorage.getItem("leditAddress"))
    },
    [ADDRESS_BACK_URL](state, { data }) {

        state.addressBackUrl = JSON.parse(aghStorage.getItem("laddressBack"))
    },
    [ADD_ADDRESS_STATUS](state, { data }) {
        state.addAddressStatus = data
    },
    [EDIT_ADDRESS_STATUS](state, { data }) {
        state.editAddressStatus = data
    },
    [DEL_ADDRESS_STATUS](state, { data }) {
        state.delAddressStatus = data
    },
    [UPDATE_ADDRESS_STATUS](state, { data }) {

        state.updateAddressStatus = data
    },
    [FOOTER_MENU_SHOW](state, { data }) {
        // console.log("data",data)
        state.isShowMergeNav = aghStorage.getItem("lisShowMergeNav")
    },
    [CORP_ID](state, { data }) {
        // console.log("data",data)
        state.corpId = data
    },
    [USER_AGENT](state, { data }) {
        // console.log("data",data)
        state.isWxAgent = aghStorage.getItem("isWxWork")
    },
    [USER_SECTION_CHECK](state, { data }) {
        // console.log("data",data)
        state.userSectionCheck = data;
    },
    [GET_USER_INFO] (state,data) {
        state.getUserInfo = data
    },
    [USER_INFO] (state,data) {
        state.userInfo = data
    },
    [USER_LOGIN_FINISH] (state,data) {
        state.userLoginFinish = data
    },
    [CURRENT_CORP_ID] (state,data) {
        state.currentCorpId = data
    },
    
    
}

export default {
    state,
    getters,
    actions,
    mutations
}